import * as React from "react";
import Lightbox from "yet-another-react-lightbox";
import {Captions, Counter, Thumbnails} from "yet-another-react-lightbox/plugins";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/counter.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";

import Slides from './Slides';
import Images from './Images';

const Photography: React.FC = () => {
    const [index, setIndex] = React.useState<number>(-1);
    
    return (
      <>
        <Images data={Slides} onClick={(focusIndex: number) => setIndex(focusIndex)}/>
        <Lightbox
          plugins={[Counter, Thumbnails, Captions]}
          thumbnails={{border: 0}}
          index={index}
          open={index >= 0}
          close={() => setIndex(-1)}
          slides={[...Slides]}
        />
      </>
    );
};

export default Photography;
